import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  menu:any[]=[{
    titulo:'Catálogo',
    icono:'nav-icon fas fa-tachometer-alt',
    submenu:[
      {titulo:'Producto',url:'producto',icono:'fa fa-users'},
      {titulo:'Gestión Pedido',url:'gestion-pedido',icono:'fa fa-users'},
      {titulo:'Gestión Pedido Detalle',url:'gestion-pedido-detalle',icono:'fa fa-users'},
      {titulo:'Categoria',url:'categoria',icono:'fa fa-users'},
      {titulo:'Código Descuento',url:'codigo-descuento',icono:'fa fa-users'}
    ]

  }]
}
